import { render } from "./PhoneSvg.vue?vue&type=template&id=1e96f9fe"
import script from "./PhoneSvg.vue?vue&type=script&lang=ts"
export * from "./PhoneSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script